import { render, staticRenderFns } from "./MenuSideBar.vue?vue&type=template&id=501069dc&scoped=true"
import script from "./MenuSideBar.vue?vue&type=script&lang=js"
export * from "./MenuSideBar.vue?vue&type=script&lang=js"
import style0 from "./MenuSideBar.vue?vue&type=style&index=0&id=501069dc&prod&lang=scss"
import style1 from "./MenuSideBar.vue?vue&type=style&index=1&id=501069dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501069dc",
  null
  
)

export default component.exports